import React, { useState } from "react";

import Alert from "../Alert/Alert";

const DismissibleAlert = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { onDismiss, ...rest } = props;
  const [showAlert, setShowAlert] = useState(true);

  return showAlert ? <Alert {...props} onDismiss={() => setShowAlert(false)} /> : null;
};

export default DismissibleAlert;
